import { Component, Injector, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize } from "rxjs/operators";
import { PermissionConstants } from "src/app/core/constants/permission-constants.constant";
import { UserPreferenceConstants } from "src/app/core/constants/user-preference-constants.constant";

import { SortOrder } from "src/app/core/interface/sort-order";
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { PageInfo } from "src/app/core/models/page-info";
import { DropdownOptionsService } from "src/app/core/services/dropdown-options.service";
import { deepCopy, getFacilityByPermission, getForwarderByPermission, isNullOrEmpty, laaSFormatString } from "src/app/core/utils/common-functions";
import { ForwarderService } from "src/app/features/transport-operation/services/forwarder.service";
import { DataTableSavedBean } from "src/app/shared/components/data-table/bean/data-table-saved-bean";
import { DataTableComponent } from "src/app/shared/components/data-table/data-table.component";
import { SessionBaseComponent } from "src/app/shared/components/session.base.component";
import { ForwarderSettingLocalData } from "./interface/forwarder-setting-local-data";
import { Option } from './interface/Option';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { ConfirmEventType } from "primeng/api";
import { LaasOption } from "src/app/core/models/laas-option";
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { FacilityService } from './../../../../core/services/facility.service';
import { AddressMaintainanceService } from './../../service/address-maintainance.service';
import { AssignmentDistrictService } from './../../service/assignment-district.service';

@Component({
  selector: 'laas-forwarder-setting-local',
  templateUrl: './forwarder-setting-local.component.html',
  styleUrls: ['./forwarder-setting-local.component.scss']
})

export class ForwarderSettingLocalComponent extends SessionBaseComponent implements OnInit {
  readonly preferenceKey: string = UserPreferenceConstants.ForwarderSetting;
  viewPermissionCode : PermissionConstants = PermissionConstants.ViewForwarderSetting;
  editPermissionCode : PermissionConstants = PermissionConstants.EditForwarderSetting;




  @ViewChild('dataTable') dataTable!: DataTableComponent;

  isLoading: boolean = false;
  isSearchFormOpen: boolean = true;
  isDataTableOpen: boolean = false;

  isInEditMode: boolean = false;
  isDropdownType : boolean = true;
  isTextType : boolean = false;

  searchParams: any;
  searchForm: FormGroup;
  assignmentDistrictId: any;
  forwarderOptions: any[] = [];
  columns: any[];
  facilityOptions: any[] = [];
  facilityList: any[] = [];
  assignmentDistrictIdFormOptions: any[] = [];
  assignmentDistrictIdTableOptions: any[] = [];
  assignmentDistrictIdConvertOptions: any[] = [];
  assignmentDistrictIdOptions: any[] = [];
  selectedRowsWithCheckBox: any[];
  poolCodeOptions: any[] = [];
  requiredFields: any[] = [];
  userOptions: any[] = [];
  forwarderType = 'Local';
  countryOptions: any[] = [];
  cityOptions: any[] = [];

  isEditForwarderSetting: boolean = false;

  forwarderFile: any = null;
  selectedFileName: string = '';
  displayImportDialog: boolean = false;
  isImportDialogLoading: boolean = false;
  isFileSelected: boolean = false;

  dataRows: ForwarderSettingLocalData[];
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  sortOrder: SortOrder = {
    property: "SeqNo",
    direction: -1
  };


  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private dropdownOptionService: DropdownOptionsService,
    private forwarderService: ForwarderService,
    private commonDataService: CommonDataService,
    private localStorageService: LocalStorageService,
    private dOService: DeliveryOrderService,
    private facilityService: FacilityService,
    private addressMaintainanceService: AddressMaintainanceService,
    private assignmentDistrictService: AssignmentDistrictService,
  ) {
    super(injector);


    this.searchForm = this.formBuilder.group({
      facility: null,
      forwarderCodes: [],
      citySeqNos: [],
      assignmentDistrictIds: []
    });
    this.dataRows = [];
    this.selectedRowsWithCheckBox = [];
    this.columns =[
      { field: 'citySeqNo', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.City', sort: true },
      { field: 'assignmentDistrictId', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.AssignmentDistrictId', sort: true },
      { field: 'forwarderCode', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.ForwarderCode', sort: true },
      { field: 'facility', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.Facility', sort: true },
      { field: 'poolCode', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.PoolCode', sort: true },
      { field: 'createDt', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.CreateDt', sort: true },
      { field: 'createUser', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.CreateUser', sort: true },
      { field: 'updateDt', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.UpdateDt', sort: true },
      { field: 'updateUser', header: 'ForwarderSetting.LocalRecommendForwarder.TableColumn.UpdateUser', sort: true },
    ];
    this.requiredFields = ['facility','assignmentDistrictId','forwarderCode'];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        if (this.facilityOptions.some(x => x.value == this.laasSetting.facility)) {
          this.facilityList = [this.laasSetting.facility]
        }
      }
    });

    this.dropdownOptionService.getForwarderOptions()
    .subscribe({
      next: (result: any[]) => {
        this.forwarderOptions = result.map((x : any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode.toString()
          }
        })
        console.log("this.forwarderOptions" ,this.forwarderOptions);
      }
    });

    this.dropdownOptionService.getUserOptions().subscribe({
      next: (options: any[]) => {
        this.userOptions = options.map(x => ({ label: x.userName, value: x.uuid}));
      }
    });


    //Authorize
    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.facilityService.getCityOptions().subscribe({
      next: (result) => {
        this.cityOptions = [...result].filter(x => (x.country == 'TW' || x.name == '香港')).map((x: any) => {
          return {
            label: x.enName + ' - ' + x.name + '-' + x.seqNo,
            value: x.seqNo,
          };
        });
        console.log('init cityOptions', this.cityOptions)
      },
    });

    // Get AssignmentDistrict Options
    this.commonDataService.getAssignmentDistrictBy(this.laasSetting.facility).subscribe({
      next: (response) => {
        this.assignmentDistrictIdOptions = response;
        this.assignmentDistrictIdConvertOptions = [...response].map((x: any) => {
          return {
            label: `${x.assignmentDistrictId} - ${x.districtName}`,
            value: x.assignmentDistrictId.toString()
          }
        })
        console.log('init assignmentDistrictIdOptions', this.assignmentDistrictIdOptions)
      }
    })
  }

  async onCityChange(event: any, type: string): Promise<void> {
    if (type === 'form') {
      this.searchForm.controls['assignmentDistrictIds'].setValue([]);
    }
    if (!Array.isArray(event.value)) {
        event.value = [event.value];
    }
    this.getAssignmentDistrictByCitySeqNos(event.value, type);
  }

  async getAssignmentDistrictByCitySeqNos(citySeqNos: any[], type: string) {
    let tempOptions = this.assignmentDistrictIdOptions.filter(x => citySeqNos.includes(x.citySeq))
      .map(x => ({
        label: `${x.assignmentDistrictId} - ${x.districtName}`,
        value: x.assignmentDistrictId.toString()
      }));
    this.assignmentDistrictIdTableOptions  = tempOptions
    if (type === 'form') {
      this.assignmentDistrictIdFormOptions = tempOptions
    }
  }

  searchBtnClick(): void{
    this.dataTable.loading = true;
    this.dataTable.cancelRowEdit();
    this.dataTable.isInEditMode = false;
    this.dataTable.setCurrentPage(0);

    const params = {
      facility: this.laasSetting.facility,
      forwarderCodes:  this.searchForm.value.forwarderCodes,
      citySeqNos: this.searchForm.value.citySeqNos,
      assignmentDistrictIds: this.searchForm.value.assignmentDistrictIds,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    }
    console.log('params',params)

    this.forwarderService.getRecommendForwarderSetting(params ,this.forwarderType)
    .pipe(finalize(()=>{
      this.dataTable.loading = false;
      this.isSearchFormOpen = false;
      this.isDataTableOpen = true;
    }))
    .subscribe({
      next: response=>{
        console.log('response',response);
        this.dataRows = deepCopy(response.content) ?? [];
        console.log('this.dataRows',this.dataRows);
        this.pageInfo.totalRecords = response.totalElements;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
        this.dataTable.updateTableData(this.dataRows);
      },
      error: (response) => {
        this.toastService.error(this.translateService.instant('Common.Toast.GetDataFail') + response.status);
      },
      complete: () => {
        this.logger.info('complete...');
      },
    })
  }

  async getPoolCodeOptions(params: any): Promise<any[]> {
    this.poolCodeOptions = await this.forwarderService.getPoolCodeOptions(params);
    console.log("poolCodeOptions",this.poolCodeOptions);

    return this.poolCodeOptions.map(x => ({
      label: x,
      value: x
    }));
  }

  async onAssignmentDistrictIdChange(event: any, rowData: any): Promise<void> {
    const facility = rowData.facility ? rowData.facility : this.laasSetting.facility;
    const params = {
      facility: this.laasSetting.facility,
      assignmentDistrictId: rowData.assignmentDistrictId,
    }

    this.assignmentDistrictIdTableOptions = this.assignmentDistrictIdOptions.filter(x => x.CitySeq === rowData.city)
    .map(x => ({
      label: `${x.assignmentDistrictId} - ${x.districtName}`,
      value: x.assignmentDistrictId.toString()
    }));

    console.log('params',params)
    this.poolCodeOptions = await this.getPoolCodeOptions(params);
    if(this.poolCodeOptions.length > 0) {
      console.log('poolCodeOptions',this.poolCodeOptions);
      this.isDropdownType = true;
      this.isTextType = false;
      // 當有選項時，清空選擇的值，防止殘留舊資料
      rowData.poolCode = '';
    } else {
      this.isDropdownType = false;
      this.isTextType = true;
      rowData.poolCode = '';
    }

  }

  onRowSelect(event: any): void {
    console.log("onRowSelect-event=", JSON.stringify(event));
    this.onCityChange({ value: [event.citySeqNo] }, '');
  }

  createNewRow(rowId: number): any {
    let newRow = {
      assignmentDistrictId: null,
      forwarderCode: null,
      poolCode: null,
      facility: this.laasSetting.facility,
      createUser: null,
      createDt: null,
      updateUser: null,
      updateDt: null,
      rowId: rowId,
    };
    return newRow;
  }

  dataInputValid = (rowData: any): boolean => {
    if(rowData){
      console.log('dataInputValid rowData', rowData)
      if(this.requiredFields.some(field => {return (isNullOrEmpty(rowData[field])) ? true : false})){
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
        return false;
      }
      console.log('forwarderOptions =', this.forwarderOptions);
      const selectedForwarder = this.forwarderOptions.find(forwarder => forwarder.value === rowData.forwarderCode);
        if (selectedForwarder) {
          const forwarderParts = selectedForwarder.label.split('-');
          rowData.forwarderName = forwarderParts[1];
        }
    }
    return true;
  }




  createRow(rowData: any): void {
    this.onRowSelect(rowData);
  }

  deleteBtnClick() {
    this.dataTable.checkedRows = this.selectedRowsWithCheckBox;
    this.dataTable.deleteRowEvent();
    this.dataTable.checkedRows = this.selectedRowsWithCheckBox;

    let deleteSeqNoList = this.selectedRowsWithCheckBox.filter(x => x.seqNo).map(x => x.seqNo);

    if (deleteSeqNoList != null && deleteSeqNoList.length > 0){
      this.confirmationService.confirm({
        message: this.translateService.instant('將移除資料庫資料，請問要刪除嗎?'),
        header: this.translateService.instant('系統資訊'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.loader.show();
          this.forwarderService.deleteRecommendForwarder(deleteSeqNoList,this.forwarderType)
          .subscribe({
            next: result => {
              this.toastService.success('資料刪除完成!!');
              this.searchBtnClick();
            },
            error: async response => {
              this.loader.hide();
              this.dataTable.loading = false;
              var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
              var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
              this.toastService.error(msg);
            },
            complete: () => {
              this.logger.info('complete...');
              this.loader.hide();
              this.dataTable.loading = false;
              this.selectedRowsWithCheckBox = [];
            }
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        }
      });
    }

  }

  saveData(savedDataBean: DataTableSavedBean): void {
    console.log('DataTableSavedBean',DataTableSavedBean);
    const saveDataRequest = {

      insertList: savedDataBean.newList,
      updateList: savedDataBean.updatedList,
      updateUser: this.userProfile.userName
    };
    console.log('saveDataRequest',saveDataRequest)

    this.forwarderService.saveRecommendForwarderSetting(saveDataRequest,this.forwarderType)
    .subscribe({
      next: () => {
        this.dataTable.saveSuccessEvent();
        this.searchBtnClick();
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
      },
      error: async (response) => {
        this.dataTable.loading = false;
        var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
        var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
        this.toastService.error(msg);
      },
      complete: () => {
        this.dataTable.loading = false;
      }
    })
  }

  onInputHandle(event:any, rowData:any) {
  }


  resetClickBtn(): void{
    this.searchForm.reset();
    this.selectedRowsWithCheckBox = [];
    this.assignmentDistrictIdFormOptions = [];
  }


  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBtnClick();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.dataTable.setCurrentPage(0);
    this.searchBtnClick();
  }

  get language(): string {
    return this.localStorageService.getItem(GlobalConstants.languageKey);
  }

  exportBtnClick() {
    const params = {
      facility: this.laasSetting.facility,
      forwarderCodes: this.searchForm.value.forwarderCodes,
      citySeqNos: this.searchForm.value.citySeqNos,
      assignmentDistrictIds: this.searchForm.value.assignmentDistrictIds
    }
    console.log('export LocalRecommendForwarder params',params)

    this.forwarderService.exportFileByRecommendForwarderType(params, 'local', this.language)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe({
        next: result => {
          if (result == null || result.size === 0) {
            this.toastService.info(this.translateService.instant('Common.Toast.NoDataFound'));
            this.loader.hide();
            return;
          }
          const file = result;
          const url = URL.createObjectURL(file);
          const a: any = document.createElement('a');
          file.name = 'LocalRecommendForwarder.xlsx';
          a.href = url;
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  showImportDialog(): void {
    this.displayImportDialog = true;
  }

  onFileSelected(event: any): void {
    this.forwarderFile = event.target.files[0];
    if (this.forwarderFile) {
      this.isFileSelected = true;
      this.selectedFileName = this.forwarderFile.name;
      event.target.value = '';
    }
  }

  uploadFile(): void {
    console.log('import facility', this.facilityList)
    if (this.facilityList == null) {
      this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.ImportFacilityEmpty'));
    }

    this.isImportDialogLoading = true;
    this.forwarderService.uploadRecommendForwarderFile(this.forwarderFile, 'local', this.facilityList).subscribe({
      next: rsp => {
        console.log('uploadFile rsp={}',rsp)
        if (rsp.flag == 'F') {
          this.toastService.success(this.translateService.instant('ForwarderSetting.Msg.Uploadsuccess'));
        }
        if (rsp.flag == 'E') {
          this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.UploadFail'));
        }
      },
      error: rsp => {
        console.log('uploadFile error', rsp);
        this.forwarderFile = undefined;
        this.isFileSelected = false;
        this.isImportDialogLoading = false;
        if (rsp.error) {
          this.toastService.error(rsp.error.errorMsg);
          let errorRowData = rsp.error.datas.join(',').replace(/,/g, '\r\n');
          this.toastService.error(errorRowData);
          return;
        }
        this.toastService.error(this.translateService.instant('ForwarderSetting.ErrorMsg.UploadFail'));
      },
      complete: () => {
        this.displayImportDialog = false;
        this.forwarderFile = undefined;
        this.isFileSelected = false;
        this.isImportDialogLoading = false;
      }
    });
  }

  downloadTemplateBtn(): void {
    var fileType = 'LocalRecommendForwarderTemplate';
    var fileName = 'Local推薦貨代範本';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        console.log('result',result)
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };
        console.log('searchObj',searchObj)
        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' });

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName + '.xlsm';
          link.click();
        });
      },
      error: err => {
        console.log('error',err)
      }
    });
  }

}
